import type { NoteCardData } from './types';

/**
 * Read-only note result card. Shows the title + a clamped body preview.
 * The whole card is clickable → onOpen() (opens the note in Drive).
 * Mirrors EmailResultCard chrome (rc-card / rc-meta).
 */
export function NoteResultCard({ data, onOpen }: { data: NoteCardData; onOpen: () => void }) {
  const { title, bodyPreview } = data;

  return (
    <button type="button" className="rc-card rc-note" onClick={onOpen}>
      <div className="rc-meta">
        <span className="rc-meta-kind">📝 NOTE</span>
      </div>

      <div className="rc-subject">{title || 'Untitled note'}</div>
      {bodyPreview && <div className="rc-note-preview">{bodyPreview}</div>}
    </button>
  );
}
